import React from "react";
import "whatwg-fetch";
import { SitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { Route, Switch, Redirect } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import componentFactory from "./temp/componentFactory";
import CompatibleSitecoreContextFactory from "./lib/SitecoreContextFactory";
import RouteHandler from "./RouteHandler";
import { Provider } from "react-redux";
import store from "./redux/store/store";
const appRoutedPaths = ["l", "p"];
// This is the main JSX entry point of the app invoked by the renderer (server or client rendering).
// By default the app's normal rendering is delegated to <RouteHandler> that handles the loading of JSS route data.

// support languages in the URL prefix
// e.g. /da-DK/path, or /en/path, or /path
export const routePatterns = [
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/l/:param_1/p/:param_2",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/l/:param_1",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/t/:param_1",

  //start: User Manual routes
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute/----:model/:category/:topic",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute/----:model/:category",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute/----:model",
  //end

  //start: e-com routes /ec/*
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/---:cat1_id/---:cat2_id/---:cat3_id/*",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/---:cat1_id/---:cat2_id/*",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/---:cat1_id--:cat1_name---:gear_type",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/---:cat1_id--:cat1_name",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/---:gear_type",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/--:brand_name",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/:spu_id--:brand_name--:product_name/:sku_id--:sku_description",
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/:spu_id--:brand_name--:product_name",
  //end

  //start: Pdp
  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/--/:service_options*",

  //end

  // "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*/m/:param_1",
  "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*",
  // "/:lang([a-z]{2})/:sitecoreRoute*/l/:param_1/p/:param_2",
  // "/:lang([a-z]{2})/:sitecoreRoute*/l/:param_1",
  // "/:lang([a-z]{2})/:sitecoreRoute*/t/:param_1",

  //start: User Manual routes
  // "/:lang([a-z]{2})/:sitecoreRoute/----:model/:category/:topic",
  // "/:lang([a-z]{2})/:sitecoreRoute/----:model/:category",
  // "/:lang([a-z]{2})/:sitecoreRoute/----:model",
  //end

  //start: Pdp
  // "/:lang([a-z]{2})/:sitecoreRoute*/--/:service_options*",
  //end

  //start: e-com routes /ec/*
  // "/:lang([a-z]{2})/:sitecoreRoute*/---:cat1_id/---:cat2_id/---:cat3_id/*",
  // "/:lang([a-z]{2})/:sitecoreRoute*/---:cat1_id/---:cat2_id/*",
  // "/:lang([a-z]{2})/:sitecoreRoute*/---:cat1_id--:cat1_name---:gear_type",
  // "/:lang([a-z]{2})/:sitecoreRoute*/---:cat1_id--:cat1_name",
  // "/:lang([a-z]{2})/:sitecoreRoute*/---:gear_type",
  // "/:lang([a-z]{2})/:sitecoreRoute*/--:brand_name",
  // "/:lang([a-z]{2})/:sitecoreRoute*/:spu_id--:brand_name--:product_name/:sku_id--:sku_description",
  // "/:lang([a-z]{2})/:sitecoreRoute*/:spu_id--:brand_name--:product_name",
  //end

  // "/:lang([a-z]{2})/:sitecoreRoute*/m/:param_1",
  "/:lang([a-z]{2})/:sitecoreRoute*",
  // "/:sitecoreRoute*/l/:param_1/p/:param_2",
  // "/:sitecoreRoute*/l/:param_1",
  // "/:sitecoreRoute*/t/:param_1",

  //start: User Manual routes
  // "/:sitecoreRoute/----:model/:category/:topic",
  // "/:sitecoreRoute/----:model/:category",
  // "/:sitecoreRoute/----:model",
  //end

  //start: e-com routes /ec/*
  // "/:sitecoreRoute*/---:cat1_id/c2-:cat2_id/c3-:cat3_id/*",
  // "/:sitecoreRoute*/---:cat1_id/c2-:cat2_id/*",
  // "/:sitecoreRoute*/---:cat1_id--:cat1_name---:gear_type",
  // "/:sitecoreRoute*/---:cat1_id--:cat1_name",
  // "/:sitecoreRoute*/---:gear_type",
  // "/:sitecoreRoute*/--:brand_name",
  // "/:sitecoreRoute*/:spu_id--:brand_name--:product_name/:sku_id--:sku_description",
  // "/:sitecoreRoute*/:spu_id--:brand_name--:product_name",
  //end

  // "/:sitecoreRoute*/m/:param_1",
  "/:sitecoreRoute*"
];

// wrap the app with:
// ApolloProvider: provides an instance of Apollo GraphQL client to the app to make Connected GraphQL queries.
//    Not needed if not using connected GraphQL.
// SitecoreContext: provides component resolution and context services via withSitecoreContext
// Router: provides a basic routing setup that will resolve Sitecore item routes and allow for language URL prefixes.
const AppRoot = ({ path, Router, graphQLClient, server }) => {
  const routeRenderFunction = props => {
    const appRoutedPathFound = appRoutedPaths.find(path => props.match.url.match(`/${path}/`)),
      handlerProps = { ...props };
    if (appRoutedPathFound && !server) handlerProps.match.params.sitecoreRoute = `/${handlerProps.match.params.sitecoreRoute}`;
    return <RouteHandler route={handlerProps} server={server} match={handlerProps.match} />;
  };

  return (
    <Provider store={store}>
      <ApolloProvider client={graphQLClient}>
        <SitecoreContext componentFactory={componentFactory} contextFactory={CompatibleSitecoreContextFactory}>
          <Router location={path} context={{}}>
            <Switch>
              {/* {path === "/" && <Route exact path="/" render={() => <Redirect to="/en/" />} />} */}
              {routePatterns.map(routePattern => {
                return <Route key={routePattern} path={routePattern} render={routeRenderFunction} />;
              })}
            </Switch>
          </Router>
        </SitecoreContext>
      </ApolloProvider>
    </Provider>
  );
};

export default AppRoot;
